"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useActiveLink = exports.activeLinkContext = exports.ActiveLinkProvider = void 0;
var _react = require("react");
var _useIsMobile = require("../../hooks/useIsMobile");
var _jsxRuntime = require("react/jsx-runtime");
const activeLinkContext = exports.activeLinkContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const {
  Provider
} = activeLinkContext;
const ActiveLinkProvider = ({
  children
}) => {
  const [activeLink, setActiveLink] = (0, _react.useState)(null);
  const isMobile = (0, _useIsMobile.useIsMobile)();
  const toggleActiveLink = (0, _react.useCallback)(link => {
    if (isMobile && activeLink === link) {
      setActiveLink(null);
    } else {
      setActiveLink(link);
    }
  }, [activeLink, isMobile]);
  const value = (0, _react.useMemo)(() => ({
    activeLink,
    toggleActiveLink
  }), [activeLink, toggleActiveLink]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: value,
    children: children
  });
};
exports.ActiveLinkProvider = ActiveLinkProvider;
const useActiveLink = () => {
  const context = (0, _react.useContext)(activeLinkContext);
  if (context) {
    return context;
  }
  throw new Error('useActiveLinkContext must be used within a ActiveLinkProvider.');
};
exports.useActiveLink = useActiveLink;
//# sourceMappingURL=activeLinkContext.js.map